import { FundRaiserStatus } from "../enums";
import {
  IAPIFundRaiserDashboardResult,
  IAPITopFundRaiser,
} from "../interfaces";
import { MediaModel } from "./GalleryModels";

export class TopFundRaiser {
  id: string;
  name: string;
  goalAmount: number;
  totalRaised: number;
  percentage: number;
  medias: MediaModel[];
  endDate?: Date; // Optional endDate for expiration badge logic
  status: keyof typeof FundRaiserStatus;
  constructor(data: Partial<TopFundRaiser> = {}) {
    this.id = data.id ?? "";
    this.name = data.name ?? "";
    this.goalAmount = data.goalAmount ?? 0;
    this.totalRaised = data.totalRaised ?? 0;
    this.percentage = data.percentage ?? 0;
    this.medias = data.medias?.map((m) => new MediaModel(m)) || [];
    this.endDate = data.endDate ? new Date(data.endDate) : undefined;
    this.status = data.status ?? FundRaiserStatus.Draft;
  }

  getImageToShow(): string {
    if (this.medias && this.medias.length > 0) {
      return (
        this.medias.filter((m) => m.type.toLowerCase() === "image")[0]
          ?.fullURL || ""
      );
    }
    return "";
  }

  static deserializeAPIModel(data: IAPITopFundRaiser): TopFundRaiser {
    return new TopFundRaiser({
      id: data.id,
      name: data.name,
      goalAmount: data.goalAmount,
      totalRaised: data.totalRaised,
      percentage: data.percentage, 
      medias: data.medias?.map(m => new MediaModel({ ...m, mediaId: m.mediaId ?? undefined })) || [], 
      endDate: data.endDate ? new Date(data.endDate) : undefined,
      status: data.status,
    });
  }
}

export class FundRaiserDashboardModel {
  totalRaised: number;
  totalRaisedThisMonth: number;
  activeFundRaisers: number;
  activeFundRaisersThisMonth: number;
  activeFundRaisersLastMonth: number;
  totalDonors: number;
  totalRaisedLastMonth: number;
  topFundRaisers: TopFundRaiser[];
  totalDonorsLastMonth: number;
  totalDonorsThisMonth: number;
  constructor(data: Partial<FundRaiserDashboardModel> = {}) {
    this.totalRaised = data.totalRaised ?? 0;
    this.totalRaisedThisMonth = data.totalRaisedThisMonth ?? 0;
    this.activeFundRaisers = data.activeFundRaisers ?? 0;
    this.totalDonors = data.totalDonors ?? 0;
    this.totalRaisedLastMonth = data.totalRaisedLastMonth ?? 0;
    this.topFundRaisers = (data.topFundRaisers ?? []).map(
      (f) => new TopFundRaiser(f)
    );
    this.activeFundRaisersLastMonth = data.activeFundRaisersLastMonth ?? 0;
    this.totalDonorsLastMonth = data.totalDonorsLastMonth ?? 0;
    this.totalDonorsThisMonth = data.totalDonorsThisMonth ?? 0;
    this.activeFundRaisersThisMonth = data.activeFundRaisersThisMonth ?? 0;
  }

  static deserializeAPIModel(
    data: IAPIFundRaiserDashboardResult
  ): FundRaiserDashboardModel {
    return new FundRaiserDashboardModel({
      totalRaised: data.totalRaised,
      totalRaisedThisMonth: data.totalRaisedThisMonth,
      activeFundRaisers: data.activeFundRaisers,
      totalDonors: data.totalDonors,
      totalRaisedLastMonth: data.totalRaisedLastMonth,
      topFundRaisers:
        data.topFundRaisers?.map(TopFundRaiser.deserializeAPIModel) || [],
      activeFundRaisersLastMonth: data.activeFundRaisersLastMonth ?? 0,
      totalDonorsLastMonth: data.totalDonorsLastMonth ?? 0,
      totalDonorsThisMonth: data.totalDonorsThisMonth ?? 0,
      activeFundRaisersThisMonth: data.activeFundRaisersThisMonth ?? 0,
    });
  }
}
